var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5398 91.0625C101.487 92.8264 101.487 95.9132 99.5398 97.6771C98.6412 98.559 97.4431 99 96.2449 99C94.897 99 93.6989 98.559 92.8003 97.6771L77.0749 82.2432L61.1997 97.6771C60.3011 98.559 59.103 99 57.9048 99C56.5569 99 55.3588 98.559 54.4602 97.6771C52.5133 95.9132 52.5133 92.8264 54.4602 91.0625L70.1856 75.4816L54.4602 60.0477C52.5133 58.2838 52.5133 55.197 54.4602 53.4332C56.2574 51.5223 59.4025 51.5223 61.1997 53.4332L77.0749 68.8671L92.8003 53.4332C94.5975 51.5223 97.7426 51.5223 99.5398 53.4332C101.487 55.197 101.487 58.2838 99.5398 60.0477L83.8144 75.6286L99.5398 91.0625Z",
    fill: "url(#paint0_linear_1535_42948)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1535_42948",
    x1: 74.5,
    y1: 49.5,
    x2: 74.5,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgError);
export default __webpack_public_path__ + "static/media/img_error.8d3f372e4842cb1ce518c1a0efe0238c.svg";
export { ForwardRef as ReactComponent };